var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupSystemDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "System_Deleted",
    "data-name": "System Deleted",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.923,
    height: 140.867,
    viewBox: "0 0 86.923 140.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_238",
    x: 19.962,
    y: 79.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_36962",
    x: 29.938,
    y: 89.074,
    width: 27.047,
    height: 24.471,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4113",
    "data-name": "Rectangle 4113",
    width: 86.923,
    height: 140.867,
    transform: "translate(0 23)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12312",
    "data-name": "Group 12312",
    transform: "translate(6183.721 12242.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6183.72, -12242.26)",
    filter: "url(#Ellipse_238)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238-2",
    "data-name": "Ellipse 238",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(21.46 80)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6183.72, -12242.26)",
    filter: "url(#Path_36962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36962-2",
    "data-name": "Path 36962",
    d: "M-172.63,371.871v21.395h12.949V371.871Zm5.382,15.892h-2.891v-2.891h2.891Zm0-4.978h-2.891v-2.891h2.891Zm0-4.978h-2.891v-2.891h2.891Zm5,9.957h-2.891v-2.891h2.891Zm0-4.978h-2.891v-2.891h2.891Zm0-4.978h-2.891v-2.891h2.891Zm13.667,4.143v11.392H-151.6v-6.008h-4.506v6.008h-3.018V381.95Zm0-2.1h-10.543v1.587h10.543Z",
    transform: "translate(204.07 -282.3)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11450",
    "data-name": "Group 11450",
    transform: "translate(0 -22.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11449",
    "data-name": "Group 11449",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11633",
    "data-name": "Path 11633",
    d: "M106.144,850.986H36.674a7.815,7.815,0,0,0-7.815,7.815l5.21,94.481a7.815,7.815,0,0,0,7.815,7.815h59.049a7.815,7.815,0,0,0,7.815-7.815l5.21-94.481a7.815,7.815,0,0,0-7.815-7.815M50.9,953.586c-.109.008-.217.01-.326.01a5.209,5.209,0,0,1-5.195-4.89l-5.21-84.687a5.21,5.21,0,0,1,10.4-.641l5.21,84.688a5.21,5.21,0,0,1-4.879,5.521m25.715-5.2a5.21,5.21,0,1,1-10.42,0V863.7a5.21,5.21,0,1,1,10.42,0Zm20.817.321a5.209,5.209,0,0,1-5.195,4.89c-.108,0-.216,0-.326-.01a5.21,5.21,0,0,1-4.879-5.521l5.21-84.687a5.21,5.21,0,0,1,10.4.641Z",
    transform: "translate(-27.036 -797.23)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11634",
    "data-name": "Path 11634",
    d: "M9.8,42.481l64.946-29.2A6.945,6.945,0,0,0,69.045.61L4.1,29.812A6.945,6.945,0,1,0,9.8,42.481M22.962,16.706,46.722,6.022a5.848,5.848,0,0,1,5.643.481l3.89-1.749a9.75,9.75,0,0,0-11.136-2.3L21.359,13.142A9.75,9.75,0,0,0,15.686,23l3.89-1.749a5.848,5.848,0,0,1,3.385-4.54",
    transform: "matrix(0.914, 0.407, -0.407, 0.914, 17.124, 7.832)",
    fill: "#3b3b3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupSystemDeleted);
export default __webpack_public_path__ + "static/media/Popup_SystemDeleted.075c5915599aa404f5842e3dcf7a98fc.svg";
export { ForwardRef as ReactComponent };